/**
 * Bloco de conteúdo com título e rodapé opcional.
 *
 * Existe para não repetir a tripla `panel` / `panel-hd` / `panel-ft` em cada
 * seção — o CSS já esperava essa estrutura antes do React, e ela continua igual.
 */
export function Panel({ title, action, footer, children }) {
  return (
    <section className="panel">
      <div className="panel-hd">
        <h2>{title}</h2>
        {action}
      </div>
      {children}
      {footer && <footer className="panel-ft">{footer}</footer>}
    </section>
  );
}
